import React, { useState } from "react";
import styles from "./Height.module.scss";

import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";
import * as appConfig from "appConfig";
import { messages } from "../Mixing.messages";
import { useIntl } from "react-intl";
import { useUi } from "@jelly/lesson";
import { SwitchOption } from "@src/lms/jelly/extensions/ui";

export const Height: React.FC = () => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const [selectedOption, setSelectedOption] = useState(0);

  return (
    <div className={styles.container}>
      {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
      <SpatialCarousel showBreadcrumbs controlsPosition="bottom">
        {[
          <div key={1} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.heightSlideTitle)}</h3>
            <ui.Scrollbars>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.heightSlideDescription) }}></p>
              <div className={styles.listContainer}>
                <div className={styles.listItem}>
                  <img
                    className={styles.listImage}
                    src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/mixing/5.png`}
                  />
                  <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.heightSlideDescription2) }}></p>
                </div>
                <div className={styles.listItem}>
                  <img
                    className={styles.listImage}
                    src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/mixing/6.png`}
                  />
                  <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.heightSlideDescription3) }}></p>
                </div>
                <div className={styles.listItem}>
                  <img
                    className={styles.listImage}
                    src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/mixing/7.png`}
                  />
                  <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.heightSlideDescription4) }}></p>
                </div>
                <div className={styles.listItem}>
                  <img
                    className={styles.listImage}
                    src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/mixing/8.png`}
                  />
                  <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.heightSlideDescription5) }}></p>
                </div>
              </div>
            </ui.Scrollbars>
          </div>,
          <div key={2} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.bedsSlideTitle)}</h3>
            <ui.Scrollbars>
              <div className={styles.listItem2}>
                <img
                  className={styles.listImage}
                  src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/mixing/6.png`}
                />
                <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.heightSlideDescription6) }}></p>
              </div>
              <p
                className={styles.shortText}
                dangerouslySetInnerHTML={{ __html: formatMessage(messages.heightSlideDescription7) }}
              ></p>
              <div className={styles.switchContainer}>
                <img
                  className={styles.image}
                  src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/mixing/${selectedOption + 9}.png`}
                />
                <SwitchOption
                  onClick={setSelectedOption}
                  activeItem={selectedOption}
                  items={[
                    {
                      name: `${formatMessage(messages.heightSlideOption)} 1`,
                    },
                    {
                      name: `${formatMessage(messages.heightSlideOption)} 2`,
                    },
                    {
                      name: `${formatMessage(messages.heightSlideOption)} 3`,
                    },
                  ]}
                />
              </div>
            </ui.Scrollbars>
          </div>,
        ]}
      </SpatialCarousel>
    </div>
  );
};
